<div *ngIf="filePath">
    <div class="title-div">
      <div class="panel-string" *ngIf="editable; else elseBlock;">
        <form [formGroup]="renameForm">
          <mat-form-field>
            <input formControlName="renameInput"  matInput [value]="stripHtml(fileName)">
            <button mat-button matSuffix mat-icon-button aria-label="Validate" (click)="changeName(filePath)">
                <mat-icon class="v-align-middle">check</mat-icon>
            </button>
        </mat-form-field>
        </form>
      </div>
      <ng-template #elseBlock>
        <div class="name-div" [innerHTML]="htmlFile?.htmlName"></div>
      </ng-template>
    </div>
    <div class="spinner-div" *ngIf="isLoading; else isNotLoading"><mat-spinner mode="indeterminate" [diameter]="50" color="primary"></mat-spinner></div>
    <ng-template #isNotLoading>
      <div class="container">
          <form #articleForm="ngForm" (ngSubmit)="onSubmit()">
            <div id="contentToConvert" *ngIf="htmlFile.htmlContent !== undefined">
             <p>
                <ckeditor class="editor"
                [disabled]="!editable"
                #isReadOnly
                [config]="editorConfig" [editor]="Editor"
                required [(ngModel)]="htmlFile.htmlContent"
                data="" name="text"></ckeditor>
             </p>
            </div>
            <div *ngIf="htmlFile.htmlContent === '' && editable" class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)">
              <mat-icon>cloud_upload</mat-icon>
              <input hidden type="file" #fileInput >
            </div>
            <button *ngIf="editable" mat-raised-button color="accent" class="submitButton" type="submit">{{'wiki.editor.submit.shortLabel'|translate}}</button>
          </form>
      </div>
    </ng-template>
    
</div>
  